import CardContent from "@material-ui/core/CardContent";
export default CardContent;